// extracted by mini-css-extract-plugin
export default {"link3DView":"Link3DView_link3DView__2Tjjw","linkContainer":"Link3DView_linkContainer__xZxAb"};